module.exports = __webpack_public_path__ + "static/leaves@2x-c0f6bdfd9e33c2c9a22ffedfda62fc72.png";